"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceFetch_1 = __importDefault(require("../../../utilities/ServiceFetch"));
var exceptions_1 = require("@ikea-aoa/exceptions");
var enums_1 = require("@ikea-aoa/enums");
var IowsShoppingBagErrorCodes_1 = __importDefault(require("./IowsShoppingBagErrorCodes"));
/**
 * This class handles CRUD operations for IOWS shopping cart API.
 */
var IowsShoppingBagService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.consumer Consumer.
     * @param options.contract Contract.
     * @param options.endpoint Endpoint.
     * @param options.clientId Client ID.
     * @param options.clientSecret Client secret.
     */
    function IowsShoppingBagService(options) {
        this.consumer = null;
        this.contract = null;
        this.consumer = options.consumer;
        this.contract = options.contract;
        this.endpoint = options.endpoint;
    }
    /**
     * Adds items to shopping cart in IRW.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @param options.items Array of shopping items.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.addToCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.addToBag({
                        userId: options.userId,
                        items: options.items,
                        shoppingBagType: enums_1.IowsShoppingBagTypeEnum.cart
                    })];
            });
        });
    };
    /**
     * Adds items to shopping list in IRW.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @param options.items Array of shopping items.
     * @param options.shoppingListName List name.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.addToList = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addToBag({
                            userId: options.userId,
                            items: options.items,
                            shoppingBagType: enums_1.IowsShoppingBagTypeEnum.list,
                            shoppingListName: options.shoppingListName
                        })];
                    case 1:
                        cart = _a.sent();
                        return [2 /*return*/, {
                                errorList: cart.errorList,
                                listCount: cart.cartCount
                            }];
                }
            });
        });
    };
    /**
     * Returns cart count for a shopping cart.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.getCartCount = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cartInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCartInfo({
                            userId: options.userId,
                            shoppingBagType: enums_1.IowsShoppingBagTypeEnum.cart
                        })];
                    case 1:
                        cartInfo = _a.sent();
                        if (cartInfo === null) {
                            return [2 /*return*/, 0];
                        }
                        return [2 /*return*/, this.getCartCountFromCart({
                                userId: options.userId,
                                shoppingBagType: enums_1.IowsShoppingBagTypeEnum.cart,
                                cartId: cartInfo.id
                            })];
                }
            });
        });
    };
    /**
     * Returns list count from a shopping list.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @param options.shoppingListName List name.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.getListCount = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cartInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCartInfo({
                            userId: options.userId,
                            shoppingBagType: enums_1.IowsShoppingBagTypeEnum.list,
                            shoppingListName: options.shoppingListName
                        })];
                    case 1:
                        cartInfo = _a.sent();
                        if (cartInfo === null) {
                            return [2 /*return*/, 0];
                        }
                        return [2 /*return*/, this.getCartCountFromCart({
                                userId: options.userId,
                                shoppingBagType: enums_1.IowsShoppingBagTypeEnum.list,
                                cartId: cartInfo.id
                            })];
                }
            });
        });
    };
    /**
     * Adds items to shopping cart in IRW.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @param options.items Array of shopping items.
     * @param options.shoppingBagType Cart type. Valid values: "cart", "list".
     * @param options.shoppingListName List name.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.addToBag = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cartInfo, updateOptions, updateInfo, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getCartInfo(options)];
                    case 1:
                        cartInfo = _b.sent();
                        if (!(cartInfo !== null)) return [3 /*break*/, 5];
                        updateOptions = Object.assign({}, options, { cartId: cartInfo.id });
                        return [4 /*yield*/, this.updateCartItems(updateOptions)];
                    case 2:
                        updateInfo = _b.sent();
                        if (!(updateInfo.cartCount === null)) return [3 /*break*/, 4];
                        _a = updateInfo;
                        return [4 /*yield*/, this.getCartCountFromCart(updateOptions)];
                    case 3:
                        _a.cartCount = _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/, updateInfo];
                    case 5: return [4 /*yield*/, this.createCart(options)];
                    case 6: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Returns cart count for a shopping cart.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @param options.cartId Cart id.
     * @param options.shoppingBagType Cart type.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.getCartCountFromCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCart(options)];
                    case 1:
                        cart = _a.sent();
                        return [2 /*return*/, cart.cartCount];
                }
            });
        });
    };
    /**
     * Returns cart information (name and id) if a cart exists.
     * Returns null if the cart doesn't exist.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @param options.shoppingBagType Cart type.
     * @param [options.shoppingListName] List name.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.getCartInfo = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.getEndpointUrl(options.userId, options.shoppingBagType), {
                            headers: this.getHeaders(),
                            credentials: 'include'
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.parseCartInfo({
                                response: response,
                                shoppingListName: options.shoppingListName
                            })];
                }
            });
        });
    };
    /**
     * Returns a shopping cart.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @param options.cartId Cart id.
     * @param options.shoppingBagType Cart type.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.getCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getEndpointUrl(options.userId, options.shoppingBagType) + '/' + options.cartId;
                        return [4 /*yield*/, ServiceFetch_1.default.json(url, {
                                headers: this.getHeaders(),
                                credentials: 'include'
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, {
                                errorList: [],
                                cartCount: this.calculateCartCountFromResponse(response)
                            }];
                }
            });
        });
    };
    /**
     * Creates a shopping cart.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @param options.shoppingBagType Cart type.
     * @param options.items Items to use.
     * @param [options.shoppingListName] List name.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.createCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var url, modelOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getEndpointUrl(options.userId, options.shoppingBagType);
                        modelOptions = {
                            userId: options.userId,
                            items: options.items,
                            shoppingBagType: options.shoppingBagType,
                            shoppingListName: options.shoppingListName
                        };
                        return [4 /*yield*/, ServiceFetch_1.default.json(url, {
                                method: 'POST',
                                headers: this.getHeaders(),
                                credentials: 'include',
                                body: 'list=' + JSON.stringify(this.createShoppingCartModel(modelOptions))
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.parseResponse(response)];
                }
            });
        });
    };
    /**
     * Updates shopping cart items.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @param options.shoppingBagType Cart type.
     * @param options.cartId Cart id.
     * @param options.items Items to use.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.updateCartItems = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var endpointUrl, url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpointUrl = this.getEndpointUrl(options.userId, options.shoppingBagType);
                        url = endpointUrl + '/' + options.cartId + '/items';
                        return [4 /*yield*/, ServiceFetch_1.default.text(url, {
                                method: 'PUT',
                                headers: this.getHeaders(),
                                credentials: 'include',
                                body: 'list=' + JSON.stringify(this.createItemsAdjustmentListModel(options.items))
                            })];
                    case 1:
                        response = _a.sent();
                        if (typeof response === 'string' && response.startsWith('{')) {
                            return [2 /*return*/, this.parseResponse(JSON.parse(response))];
                        }
                        return [2 /*return*/, {
                                cartCount: null,
                                errorList: []
                            }];
                }
            });
        });
    };
    /**
     * Parses response.
     *
     * @param response Response.
     * @returns Promise object.
     */
    IowsShoppingBagService.prototype.parseResponse = function (response) {
        var cartCount = this.calculateCartCountFromResponse(response);
        var parsed = {
            cartCount: cartCount,
            errorList: []
        };
        if (typeof response === 'object' && response !== null && response.ErrorList) {
            var errorObject = response.ErrorList.Error;
            var errorList = Array.isArray(errorObject) ? errorObject : [errorObject];
            for (var _i = 0, errorList_1 = errorList; _i < errorList_1.length; _i++) {
                var error = errorList_1[_i];
                var errorMessage = error.ErrorMessage || {};
                var errorCode = error.ErrorCode || {};
                var message = errorMessage.$ ? errorMessage.$ : null;
                var code = errorCode.$ ? errorCode.$ : null;
                var items = [];
                if (error.ErrorAttributeList && Array.isArray(error.ErrorAttributeList.ErrorAttribute)) {
                    for (var _a = 0, _b = error.ErrorAttributeList.ErrorAttribute; _a < _b.length; _a++) {
                        var attribute = _b[_a];
                        if (attribute.Value && attribute.Value.$) {
                            items.push(String(attribute.Value.$));
                        }
                    }
                }
                parsed.errorList.push({
                    code: IowsShoppingBagErrorCodes_1.default[code] || String(code),
                    message: message,
                    items: items
                });
            }
        }
        return parsed;
    };
    /**
     * Calculates cart count from data.
     *
     * @param response Data returned from the response.
     * @returns Cart count or error object.
     */
    IowsShoppingBagService.prototype.calculateCartCountFromResponse = function (response) {
        var bag = response.ShoppingBag || {};
        bag.ShoppingBagSectionList = bag.ShoppingBagSectionList || {};
        bag.ShoppingBagSectionList.ShoppingBagSection =
            bag.ShoppingBagSectionList.ShoppingBagSection || {};
        bag.BagType = bag.BagType || { $: '' };
        var isCart = bag.BagType.$ === 'ONLINESHOPPINGCART';
        var isList = bag.BagType.$ === 'ONLINESHOPPINGLIST';
        var itemList = bag.ShoppingBagSectionList.ShoppingBagSection.ShoppingBagItemList;
        var cartCount = null;
        if ((isCart || isList) && itemList) {
            var items = itemList.ShoppingBagItem;
            var array = Array.isArray(items) ? items : [items];
            cartCount = 0;
            for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                var item = array_1[_i];
                if (item.ItemQty) {
                    cartCount += item.ItemQty.$;
                }
            }
        }
        return cartCount;
    };
    /**
     * Parses cart data and returns cart info.
     *
     * @param options Options.
     * @param options.response Response.
     * @param [options.shoppingListName] List name.
     * @returns Parsed data.
     */
    IowsShoppingBagService.prototype.parseCartInfo = function (options) {
        var response = options.response, shoppingListName = options.shoppingListName;
        var cartInfo = null;
        if (response.ShoppingBag && response.ShoppingBag.BagId) {
            cartInfo = {
                id: response.ShoppingBag.BagId.$,
                name: response.ShoppingBag.BagName && response.ShoppingBag.BagName.$
                    ? response.ShoppingBag.BagName.$
                    : null,
                type: response.ShoppingBag.BagType && response.ShoppingBag.BagType.$
                    ? response.ShoppingBag.BagType.$.toLowerCase()
                    : null
            };
        }
        else if (response.ShoppingBagRefList && response.ShoppingBagRefList.ShoppingBagRef) {
            if (Array.isArray(response.ShoppingBagRefList.ShoppingBagRef)) {
                for (var _i = 0, _a = response.ShoppingBagRefList.ShoppingBagRef; _i < _a.length; _i++) {
                    var ref = _a[_i];
                    if (ref.BagId &&
                        (!ref.BagName ||
                            !ref.BagName.$ ||
                            !ref.BagType ||
                            !ref.BagType.$ ||
                            ref.BagName.$ === shoppingListName)) {
                        cartInfo = {
                            id: ref.BagId.$,
                            name: ref.BagName && ref.BagName.$ ? ref.BagName.$ : null,
                            type: ref.BagType && ref.BagType.$ ? ref.BagType.$.toLowerCase() : null
                        };
                        break;
                    }
                }
            }
            else if (response.ShoppingBagRefList.ShoppingBagRef.BagId) {
                var ref = response.ShoppingBagRefList.ShoppingBagRef;
                cartInfo = {
                    id: ref.BagId.$,
                    name: ref.BagName && ref.BagName.$ ? ref.BagName.$ : null,
                    type: ref.BagType && ref.BagType.$ ? ref.BagType.$.toLowerCase() : null
                };
            }
        }
        if (cartInfo && cartInfo.type && cartInfo.name && cartInfo.name !== shoppingListName) {
            return null;
        }
        return cartInfo;
    };
    /**
     * Generates a shopping cart model to be used as JSON.
     *
     * @param options Options.
     * @param options.userId User ID.
     * @param options.items Items to use.
     * @param options.shoppingBagType Cart type.
     * @param [options.shoppingListName] List name.
     * @param [options.cartId] Cart id.
     * @param options.bagId
     * @returns Shopping cart model.
     */
    IowsShoppingBagService.prototype.createShoppingCartModel = function (options) {
        var shoppingListName = options.shoppingListName || options.shoppingBagType;
        var json = {
            ShoppingBag: {
                BagType: {
                    $: options.shoppingBagType
                },
                BagSource: {
                    $: 'IRW'
                },
                BagName: {
                    $: shoppingListName
                },
                CustomerSource: {
                    $: 'IRW'
                },
                CustomerId: {
                    $: options.userId
                },
                CreatedDateTime: {
                    $: this.getCreatedTime()
                },
                ShoppingBagSectionList: [
                    {
                        ShoppingBagSection: {
                            ShoppingBagItemList: {
                                ShoppingBagItem: []
                            }
                        }
                    }
                ],
                '@xmlns': {
                    $: 'ikea.com/cem/iows/ShoppingBagService/2.0/'
                }
            }
        };
        var list = json.ShoppingBag.ShoppingBagSectionList[0].ShoppingBagSection.ShoppingBagItemList
            .ShoppingBagItem;
        for (var _i = 0, _a = options.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (typeof item.id !== 'string' ||
                typeof item.type !== 'string' ||
                typeof item.quantity !== 'number') {
                throw new exceptions_1.ServiceException('Item was not in a valid format. Please use this format: { id: 123456, type: "ART", quantity: 1 }');
            }
            list.push({
                ItemType: {
                    $: item.type.toUpperCase()
                },
                ItemNo: {
                    $: item.id
                },
                ItemQty: {
                    $: item.quantity
                }
            });
        }
        if (options.bagId) {
            json['BagId'] = {
                $: options.bagId
            };
        }
        return json;
    };
    /**
     * Generates a shopping cart adjustment list model to be used as JSON.
     *
     * @param items Items to use.
     * @returns Shopping cart model.
     */
    IowsShoppingBagService.prototype.createItemsAdjustmentListModel = function (items) {
        var json = {
            ShoppingBagAdjustmentItemList: {
                ShoppingBagAdjustmentItem: [],
                '@xmlns': {
                    $: 'ikea.com/cem/iows/ShoppingBagService/2.0/'
                }
            }
        };
        var list = json.ShoppingBagAdjustmentItemList.ShoppingBagAdjustmentItem;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (typeof item.id !== 'string' ||
                typeof item.type !== 'string' ||
                typeof item.quantity !== 'number') {
                throw new exceptions_1.ServiceException('Item was not in a valid format. Please use this format: { id: 123456, type: "ART", quantity: 1 }');
            }
            list.push({
                ItemType: {
                    $: item.type.toUpperCase()
                },
                ItemNo: {
                    $: item.id
                },
                ItemQty: {
                    $: item.quantity
                },
                SectionId: {
                    $: 0
                }
            });
        }
        return json;
    };
    /**
     * Returns headers to be used by requests.
     *
     * @returns Object as key value pairs of headers.
     */
    IowsShoppingBagService.prototype.getHeaders = function () {
        return {
            accept: 'application/vnd.ikea.iows+json; version=2.0',
            contract: String(this.contract),
            consumer: this.consumer,
            'content-type': 'application/x-www-form-urlencoded'
        };
    };
    /**
     * Returns endpoint URL.
     *
     * @param userId User id.
     * @param shoppingBagType Cart type. Valid values: "cart", "list".
     * @returns Endpoint url.
     */
    IowsShoppingBagService.prototype.getEndpointUrl = function (userId, shoppingBagType) {
        return this.endpoint
            .replace('{userId}', userId)
            .replace('{bagType}', shoppingBagType.toLowerCase());
    };
    /**
     * Returns a date ISO string of the current time.
     *
     * @returns Date ISO string.
     */
    IowsShoppingBagService.prototype.getCreatedTime = function () {
        return new Date().toISOString();
    };
    return IowsShoppingBagService;
}());
exports.default = IowsShoppingBagService;
//# sourceMappingURL=IowsShoppingBagService.js.map